import {Component} from "preact";
import {connect} from "redux-zero/preact";
import actions from "../../store/actions";
import {withDeviceIndicator} from "../../hoc/withDeviceIndicator";
import {productService} from "../../services/product-service";
import App from "../../components/app";
import {ArchiveProduct} from "../../models/product";
import {icons} from "../../components/icons";
import style from "./style.module.scss"
import {i18nService} from "../../services/i18n-service";

interface State {
  productId: string;
  product: ArchiveProduct | undefined;
  textInputActive: boolean;
  showError: boolean;
}

export class Archive extends Component<any, State> {
  private onChangeProductId(productId: string) {
    let digits = productId.replace(/\D/g, '');

    let formatted = '';
    if (digits.length > 0) formatted += digits.substring(0, 2);
    if (digits.length > 2) formatted += `.${digits.substring(2, 4)}`;
    if (digits.length > 4) formatted += `.${digits.substring(4, 7)}`;
    if (digits.length > 7) formatted += `.${digits.substring(7, 11)}`;

    this.setState({
      productId: formatted,
      product: undefined,
      showError: false
    });

    if (/^\d{2}\.\d{2}\.\d{3}\.\d{4}$/.test(formatted)) {
      productService.loadArchiveProductById(productId, App.countryCode).then(product => {
        this.setState({
          product: product,
          showError: product == null
        });
      })
    }
  }

  private focusInput() {
    this.setState({textInputActive: true});

    setTimeout(() => {
      const input = document.querySelector('input');
      input?.focus()
    }, 1)
  }

  private onFocusOut() {
    const input = document.querySelector('input');

    if(input?.value.length === 0) {
      this.setState({textInputActive: false});
    }
  }

  private clearInput() {
    this.setState({
      productId: "",
      product: undefined,
      showError: false
    });
  }

  private goBack() {
    window.history.back();
  }

  render() {
    return (
      <div class={style.archive}>
        <h1 class={style.headline}>{i18nService.translate("archive_headline")}</h1>

        <div class={style.header}>
          <div onClick={this.goBack} class={style.back}>{icons.renderArrowLeftIcon()}</div>
          <span>{i18nService.translate("archive_title")}</span>
        </div>

        <div className={`${style.input} ${this.state.textInputActive ? style.active : ""}`} onClick={() => this.focusInput()}>
          <div className={style.label}>
            {!this.state.textInputActive && <div className={style.icon}>{icons.renderMagnifyingGlassIcon()}</div>}
            <span>{i18nService.translate("archive_search_placeholder")}</span>
          </div>

          {this.state.textInputActive && (
            <div className={style.field}>
              <input
                value={this.state.productId}
                onFocusOut={this.onFocusOut.bind(this)}
                onInput={e => this.onChangeProductId((e.target as HTMLInputElement).value)}
                type={"text"}
                inputMode={"numeric"}
                maxLength={14}
              />

              {this.state.productId && <div onClick={this.clearInput.bind(this)} class={style.remove}>{icons.renderCloseIcon()}</div>}
            </div>
          )}
        </div>

        {this.state.showError && (
          <div className={style.error}>
            {icons.renderInfoFilledIcon()}
            <span className={style.title}>{i18nService.translate("archive_product_not_found_title")}</span>
            <span>{i18nService.translate("archive_product_not_found_description")}</span>
          </div>
        )}

        {this.state.product && (
          <div className={style.details}>
            <div className={style.row}>
              <span>{i18nService.translate("product_name")}: <span className={style.value}>{this.state.product.name}</span></span>
              <span>{i18nService.translate("product_id")}: <span className={style.value}>{this.state.product.id}</span></span>
            </div>

            <div className={style.row}>
              <span>{i18nService.translate("epr_recycled_label")}</span>
              <span className={style.value}>{this.state.product.recycled_material}</span>
            </div>

            <div className={style.row}>
              <span>{i18nService.translate("epr_dangerous_material_label")}</span>
                {this.state.product.dangerous_substance ? (
                  <span className={style.value}>{i18nService.translate("epr_dangerous_material_contains")}</span>
                ):(
                  <span className={style.value}>{i18nService.translate("epr_dangerous_material_contains_not")}</span>
                )}
            </div>

            <div className={style.row}>
              <span>{i18nService.translate("archive_microplastic")}</span>
                {this.state.product.contains_high_microplastic ? (
                  <span className={style.value}>{i18nService.translate("epr_reject_microplastic")}</span>
                ):(
                  <span className={style.value}>{i18nService.translate("no")}</span>
                )}
            </div>

            <div className={style.row}>
              <span>{i18nService.translate("epr_fabrication_country")}</span>
              <span className={style.value}>{this.state.product.fabrication_country}</span>
            </div>

            <div className={style.row}>
                <span>{i18nService.translate("epr_enhancement_country")}</span>
                <span className={style.value}>{this.state.product.enhancement_country}</span>
            </div>

            <div className={style.row}>
                <span>{i18nService.translate("epr_assembling_country")}</span>
                <span className={style.value}>{this.state.product.assembling_country}</span>
            </div>
          </div>
        )}
      </div>
    )
  }
}

export default connect(({}) => ({}), actions)(withDeviceIndicator(Archive));
